
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { CreateFacilityOrderTemplateNewFlowModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { CreateFacilityOrderTemplateNewFlowModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new CreateFacilityOrderTemplateNewFlowModalStore(rootStore, componentProps), 'createFacilityOrderTemplateNewFlowModalStore')
@observer
class CreateFacilityOrderTemplateNewFlowModal extends React.Component {
    render() {
        return <CreateFacilityOrderTemplateNewFlowModalTemplate {...this.props} />
    }
}

export default CreateFacilityOrderTemplateNewFlowModal;
